import { rootApi } from "../../api/rootApi";

export const ecommerceProductApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    // Fetch all ecommerce products
    fetchEcommerceProducts: builder.mutation({
      query: ({ slug, token, ...body }) => ({
        url: `/tenant/ecommerce/products/all`,
        method: "POST",
        headers: {
          slug,
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body,
      }),
    }),

    // Add new ecommerce product
    addEcommerceProduct: builder.mutation({
      query: ({ slug, token, ...body }) => ({
        url: `/tenant/ecommerce/products/add`,
        method: "POST",
        headers: {
          slug,
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body,
      }),
    }),

    // Bulk add ecommerce products
    bulkAddEcommerceProduct: builder.mutation({
      query: ({ slug, token, ...body }) => ({
        url: `/tenant/ecommerce/products/bulk-add`,
        method: "POST",
        headers: {
          slug,
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body,
      }),
    }),

    // Update ecommerce product
    updateEcommerceProduct: builder.mutation({
      query: ({ slug, token, ...body }) => ({
        url: `/tenant/ecommerce/products/update`,
        method: "POST",
        headers: {
          slug,
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body,
      }),
    }),

    // Fetch single ecommerce product
    fetchEcommerceProductById: builder.mutation({
      query: ({ slug, token, id }) => ({
        url: `/tenant/ecommerce/products/all`,
        method: "POST",
        headers: {
          slug,
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: { id },
      }),
    }),
  }),
});

export const {
  useFetchEcommerceProductsMutation,
  useAddEcommerceProductMutation,
  useBulkAddEcommerceProductMutation,
  useUpdateEcommerceProductMutation,
  useFetchEcommerceProductByIdMutation,
} = ecommerceProductApi;
